/* NorthPlanner · runtime de la landing (ES y EN comparten estructura).
   Sustituye a los scripts de PageFly. Se carga con defer, así que el DOM ya
   está montado. Solo puede existir un #npl-root por página.

   Los ganchos (npl-root, data-npl-type, npl-acc-panel) están renombrados a
   propósito: si se llamaran como los de PageFly, el JavaScript de la app
   los capturaría también y pelearía con este. */
(function () {
  var root = document.getElementById('npl-root');
  if (!root || root.dataset.nplReady) return;
  root.dataset.nplReady = '1';

  var L = { prev: 'Previous', next: 'Next', goto: 'Go to slide', close: 'Close' };
  var holder = root.closest('[data-npl-labels]');
  if (holder) { try { L = JSON.parse(holder.getAttribute('data-npl-labels')); } catch (e) {} }

  var CHEV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

  /* ─────────── Vídeo del hero: se carga tras el primer pintado ─────────── */
  function loadVideos() {
    Array.prototype.forEach.call(root.querySelectorAll('video[data-npl-src]'), function (v) {
      v.muted = true; v.defaultMuted = true; v.playsInline = true; v.preload = 'auto';
      v.src = v.getAttribute('data-npl-src'); v.removeAttribute('data-npl-src');
      var go = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      v.addEventListener('canplay', go, { once: true }); go();
      document.addEventListener('touchstart', go, { once: true, passive: true });
      document.addEventListener('click', go, { once: true });
    });
  }
  if ('requestIdleCallback' in window) requestIdleCallback(loadVideos, { timeout: 1200 });
  else setTimeout(loadVideos, 600);

  /* ────────────────────────────── Acordeón ────────────────────────────── */
  var accRoot = root.querySelector('[data-npl-type="Accordion"]');
  var multiple = accRoot ? accRoot.getAttribute('data-multiple') === 'true' : false;
  var headers = root.querySelectorAll('[data-npl-type="Accordion.Header"]');

  function panelOf(b) {
    var e = b.nextElementSibling;
    while (e && !e.classList.contains('npl-acc-panel')) e = e.nextElementSibling;
    return e;
  }
  function closeAcc(b) {
    var p = panelOf(b); if (!p) return;
    p.style.height = p.scrollHeight + 'px'; void p.offsetHeight; p.style.height = '0px';
    b.setAttribute('data-active', 'false'); b.setAttribute('aria-expanded', 'false');
    p.classList.add('npl-acc-hide');
  }
  function openAcc(b) {
    var p = panelOf(b); if (!p) return;
    p.classList.remove('npl-acc-hide'); p.style.height = p.scrollHeight + 'px';
    b.setAttribute('data-active', 'true'); b.setAttribute('aria-expanded', 'true');
    var done = function () { if (b.getAttribute('aria-expanded') === 'true') p.style.height = 'auto'; };
    p.addEventListener('transitionend', done, { once: true }); setTimeout(done, 450);
  }
  Array.prototype.forEach.call(headers, function (b) {
    var p = panelOf(b);
    if (p) { p.classList.add('npl-acc-hide'); p.style.height = '0px'; }
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var isOpen = b.getAttribute('aria-expanded') === 'true';
      if (!multiple) Array.prototype.forEach.call(headers, function (o) {
        if (o !== b && o.getAttribute('aria-expanded') === 'true') closeAcc(o);
      });
      isOpen ? closeAcc(b) : openAcc(b);
    });
  });
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      Array.prototype.forEach.call(headers, function (b) {
        if (b.getAttribute('aria-expanded') === 'true') {
          var p = panelOf(b); if (p) p.style.height = 'auto';
        }
      });
    }, 150);
  });

  /* ───────────────────────────── Carruseles ───────────────────────────── */
  /* Las rejillas hacen wrap y se ven enteras; solo las nowrap necesitan
     flechas y puntos. El desplazamiento lo hace el scroll-snap nativo. */
  function setupSlider(sl) {
    if (getComputedStyle(sl).flexWrap !== 'nowrap') return;
    var slides = sl.querySelectorAll(':scope > .pf-slide');
    if (slides.length < 2) return;
    var wrap = sl.parentElement;
    wrap.classList.add('npl-sl-wrap');

    function perView() {
      var w = slides[0].getBoundingClientRect().width;
      return w > 0 ? Math.max(1, Math.round(sl.clientWidth / w)) : 1;
    }
    function pages() { return Math.max(1, Math.ceil(slides.length / perView())); }
    function current() {
      var w = slides[0].getBoundingClientRect().width * perView();
      return w > 0 ? Math.round(sl.scrollLeft / w) : 0;
    }
    if (pages() < 2) return;

    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'npl-sl-btn npl-sl-prev';
    prev.setAttribute('aria-label', L.prev);
    prev.innerHTML = CHEV; prev.firstChild.style.transform = 'rotate(180deg)';
    var next = prev.cloneNode(true);
    next.className = 'npl-sl-btn npl-sl-next';
    next.setAttribute('aria-label', L.next);
    next.firstChild.style.transform = '';
    var dots = document.createElement('div');
    dots.className = 'npl-sl-dots';
    wrap.appendChild(prev); wrap.appendChild(next); wrap.appendChild(dots);

    function go(i) {
      sl.scrollTo({ left: i * slides[0].getBoundingClientRect().width * perView(),
                    behavior: 'smooth' });
    }
    function render() {
      var n = pages(), cur = Math.min(current(), n - 1);
      if (dots.childElementCount !== n) {
        dots.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'npl-sl-dot';
          d.setAttribute('aria-label', L.goto + ' ' + (i + 1));
          d.dataset.i = i; dots.appendChild(d);
        }
      }
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.setAttribute('aria-current', i === cur ? 'true' : 'false');
      });
      prev.disabled = cur <= 0; next.disabled = cur >= n - 1;
    }
    prev.addEventListener('click', function () { go(Math.max(0, current() - 1)); });
    next.addEventListener('click', function () { go(Math.min(pages() - 1, current() + 1)); });
    dots.addEventListener('click', function (e) {
      var d = e.target.closest('.npl-sl-dot'); if (d) go(+d.dataset.i);
    });
    var t;
    sl.addEventListener('scroll', function () {
      clearTimeout(t); t = setTimeout(render, 80);
    }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(render, 150); });
    render();
  }
  Array.prototype.forEach.call(root.querySelectorAll('.pf-slider'), setupSlider);

  /* ─────────────────────────── Ir a sección ───────────────────────────── */
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-npl-scroll]');
    if (!a) return;
    e.preventDefault();
    var id = a.getAttribute('data-npl-scroll');
    var t = document.getElementById(id) || root.querySelector('[data-npl-section="' + id + '"]');
    /* Si el botón está dentro de su propio destino, saltar no serviría de
       nada: se manda al formulario de compra real del tema. */
    if (!t || t.contains(a)) {
      t = document.querySelector('product-form, form[action*="/cart/add"], .product-form');
    }
    if (!t) return;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 50,
                      behavior: 'smooth' });
  });

  /* ────────────────────────── Ventana del vídeo ───────────────────────── */
  var modal, frame, lastFocus;
  function buildModal() {
    modal = document.createElement('div');
    modal.id = 'npl-modal'; modal.hidden = true;
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="npl-modal-bg"></div>' +
      '<div class="npl-modal-box">' +
        '<button class="npl-modal-x" type="button" aria-label="' + L.close + '">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<iframe allow="autoplay; encrypted-media; picture-in-picture; fullscreen" ' +
        'allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>' +
      '</div>';
    document.body.appendChild(modal);
    frame = modal.querySelector('iframe');
    modal.querySelector('.npl-modal-x').addEventListener('click', closeModal);
    /* Cerrar al pulsar la zona oscurecida: vale tanto el fondo como cualquier
       hueco del contenedor que no sea el vídeo ni el botón. */
    modal.addEventListener('click', function (ev) {
      if (!ev.target.closest('.npl-modal-box')) closeModal();
    });
    modal.addEventListener('touchstart', function (ev) {
      if (!ev.target.closest('.npl-modal-box')) closeModal();
    }, { passive: true });
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true; frame.src = 'about:blank';
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
  });
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-npl-modal]');
    if (!a) return;
    e.preventDefault();
    if (!modal) buildModal();
    lastFocus = a;
    frame.title = a.getAttribute('data-npl-title') || '';
    frame.src = a.getAttribute('data-npl-modal');
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    modal.querySelector('.npl-modal-x').focus();
  });
})();
